<template>
  <td class="indigo lighten-3 pa-2 overview-block" style="min-width: 150px; max-width: 150px; vertical-align: top">
    <div>Total in bookings : {{ totalInBooking }}</div>
    <div v-if="isGeneratedFromQuote">Total in quote : {{ totalInQuote }}</div>
    <div v-if="isGeneratedFromQuote" :class="getValueClass">Delta : {{ delta }}</div>
  </td>
</template>

<script>
import { ProductService } from "@/modules/products";
import { SUPPLIER_TYPES, PRODUCT_TYPES } from "@/config/TYPES";
import { supplierTypeToDbKeyMap } from "@/config/SUPPLIER_PRODUCT_TYPE_MAP";
import moneyService from "@/services/money";
import DateFormat from "@/services/format";
export default {
  props: {
    typeAs: String,
  },
  computed: {
    totalInBooking() {
      if (!this.dbKey) return 0;

      const days = this.$store.getters["BookingDayStore/days"];
      const suppliers = this.$store.getters["BookingDayStore/suppliers"];
      const workingEnv = this.$store.getters["AccountStore/environment"];

      let total = 0;
      days.forEach((booking) => {
        const bookingSupplierIds = booking[this.dbKey] || [];
        bookingSupplierIds.forEach((supplierId) => {
          const supplier = suppliers[supplierId];
          if (supplier && supplier.products) {
            Object.values(supplier.products).forEach((product) => {
              if (product.product_type === PRODUCT_TYPES.EXPENSE) return;
              total += this.getProductRateValue(supplier, product, workingEnv);
            });
          }
        });
      });

      return total.toFixed(0);
    },
    totalInQuote() {
      if (!this.isGeneratedFromQuote) return 0;
      if (!this.dbKey) return 0;

      const days = this.$store.getters["BookingDayStore/days"];
      const suppliers = this.$store.getters["BookingDayStore/suppliers"];

      let total = 0;
      days.forEach((booking) => {
        const bookingSupplierIds = booking[this.dbKey] || [];
        bookingSupplierIds.forEach((supplierId) => {
          const supplier = suppliers[supplierId];
          if (supplier && supplier.meta && supplier.meta.quote_price) {
            Object.keys(supplier.meta.quote_price).forEach((productId) => {
              const product = (supplier.products || {})[productId];
              if (product && product.product_type === PRODUCT_TYPES.EXPENSE) return;

              const quotePrice = supplier.meta.quote_price[productId];
              total += moneyService.stripFormatting(quotePrice.value);
            });
          }
        });
      });

      return total.toFixed(0);
    },
    delta() {
      if (!this.isGeneratedFromQuote) return 0;
      const delta = this.totalInBooking - this.totalInQuote;
      return delta;
    },
    isGeneratedFromQuote() {
      const bookingData = this.$store.getters["BookingStore/data"];
      return bookingData.quote != null;
    },
    getValueClass() {
      return `font-weight-bold ${this.totalInBooking > this.totalInQuote ? "red-text" : "green-text"}`;
    },
    dbKey() {
      return supplierTypeToDbKeyMap[this.typeAs] || null;
    },
  },
  methods: {
    // TODO: This method comes from _ProductPriceHover. Will check how it works later.
    getProductRateValue(supplier, product, environment) {
      const useDates = supplier.meta && supplier.meta.use_dates;
      const dateDefault = {
        from_month: DateFormat.dateToObj(this.date).month,
        from_day: DateFormat.dateToObj(this.date).day,
      };

      const customPrices = supplier.meta ? { ...supplier.meta.custom_prices } : {};
      const customPricesV2 = supplier.meta ? { ...supplier.meta.custom_prices_v2 } : {};

      const prices = ProductService.getPrice(
        product,
        supplier.supplier_meta,
        supplier.country,
        customPrices,
        customPricesV2,
        this.$store.getters,
        true,
        useDates || dateDefault,
        supplier.meta
      );

      if (!product.seasonal) {
        const locked = supplier.locked_prices && supplier.locked_prices[product.id];
        const rate = locked ? ProductService.formatPrice(locked.totalPrice) : prices.totalPrice_print;
        return moneyService.stripFormatting(rate, environment);
      }

      if (!prices || prices.length === 0) {
        return 0;
      }

      const defaultType = prices[0].defaultType === "PROOM" ? "DOUBLE_QK" : "DEFAULT";
      const emptyPriceIndex = prices.findIndex((p) => p.roomType == null || p.roomType === "");
      const defaultPriceIndex = prices.findIndex((p) => p.roomType === defaultType);
      const index = defaultPriceIndex !== -1 ? defaultPriceIndex : emptyPriceIndex !== -1 ? emptyPriceIndex : -1;

      if (index === -1) return 0;

      const p = prices[index];
      const locked =
        supplier.locked_prices && supplier.locked_prices[product.id] && supplier.locked_prices[product.id][index];
      const rate = locked ? ProductService.formatPrice(locked.totalPrice) : p.totalPrice_print;
      return moneyService.stripFormatting(rate, environment);
    },
  },
};
</script>
